import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Checkbox from 'material-ui/Checkbox';
import DatePicker from 'material-ui/DatePicker';
import { push } from 'react-router-redux';
import dateFormat from 'dateformat';
import moment from 'moment';
import SimpleFormWrapper from '../components/SimpleFormWrapper';
import { register } from '../actions/userActions';
import i18n from '../utils/i18n';
import { gender, MIN_PASSWORD_LENGTH } from '../utils/constants';
import routeConstants from '../utils/routeConstants';
import { scrollScreenToTop } from '../utils/other';

import './styles/RegisterContainer.scss';

class RegisterContainer extends React.Component {
  static isOver18(birthDate) {
    return (
      moment.duration(moment(new Date()) - moment(birthDate)).asYears() >= 18
    );
  }

  constructor(props) {
    super(props);

    this.state = {
      user: {
        email: '',
        password: '',
        firstName: '',
        lastName: '',
        termsAccepted: false,
        birthDate: null,
        gender: '',
        postcode: '',
        emergency_name: '',
        emergency_phone_number: '',
        emergency_relationship: '',
        emergency_existing_conditions: '',
        confirmEmail: '',
        confirmPassword: ''
      },
      errors: {
        firstName: '',
        email: '',
        password: '',
        termsAccepted: '',
        birthDate: '',
        gender: '',
        postcode: '',
        emergency_name: '',
        emergency_phone_number: '',
        emergency_relationship: ''
      },
      inviteHash: '',
      page: 1
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleBirthDateChange = this.handleBirthDateChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleTermsAccepted = this.toggleTermsAccepted.bind(this);
    this.routeToSignIn = this.routeToSignIn.bind(this);
  }

  componentWillReceiveProps(props) {
    if (props.inviteHash && props.inviteEmail) {
      const { user } = this.state;
      this.setState({
        user: {
          ...user,
          email: props.inviteEmail,
          confirmEmail: props.inviteEmail
        },
        inviteHash: props.inviteHash
      });
    }
  }

  handleChange(event) {
    const { name, value } = event.target;
    const { user, errors } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: value
      },
      errors: {
        ...errors,
        [name]: false
      }
    });
  }

  handleBirthDateChange(event, date) {
    const { user, errors } = this.state;
    this.setState({
      user: {
        ...user,
        birthDate: date
      },
      errors: {
        ...errors,
        birthDate: false
      }
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const { page } = this.state;

    if (page === 1) {
      this.handleFirstPageSubmit();
    } else {
      this.handleSecondPageSubmit();
    }
    switch (page) {
    case 1: {
      this.handleFirstPageSubmit();
      break;
    }
    case 2: {
      this.handleSecondPageSubmit();
      break;
    }
    case 3:
    default: {
      this.handleThirdPageSubmit();
      break;
    }
    }
  }

  handleFirstPageSubmit() {
    const { user } = this.state;
    if (
      user.email &&
      user.password &&
      user.email === user.confirmEmail &&
      user.password === user.confirmPassword &&
      user.password.length >= MIN_PASSWORD_LENGTH
    ) {
      this.goToPage(2);
    } else {
      const errors = Object.assign({}, this.state.errors);

      if (!user.email) {
        errors.email = i18n.t('registerLoginScreens.EMAIL_REQUIRED');
      }
      if (user.email !== user.confirmEmail) {
        errors.email = i18n.t('registerLoginScreens.WRONG_EMAIL_CONFIRMATION');
      }
      if (!user.password) {
        errors.password = i18n.t('registerLoginScreens.PASSWORD_REQUIRED');
      }
      if (user.password !== user.confirmPassword) {
        errors.password = i18n.t(
          'registerLoginScreens.WRONG_PASSWORD_CONFIRMATION'
        );
      }
      if (user.password.length < MIN_PASSWORD_LENGTH) {
        errors.password = i18n.t('registerLoginScreens.PASSWORD_MIN_LENGTH');
      }

      this.setState({
        errors
      });
    }
  }

  handleSecondPageSubmit() {
    const { user } = this.state;
    const errors = Object.assign({}, this.state.errors);

    if (
      user.firstName &&
      user.lastName &&
      user.gender &&
      user.birthDate &&
      user.postcode &&
      user.termsAccepted &&
      RegisterContainer.isOver18(user.birthDate)
    ) {
      this.goToPage(3);
    } else {
      if (!user.firstName) {
        errors.firstName = i18n.t('registerLoginScreens.FIRST_NAME_REQUIRED');
      }
      if (!user.lastName) {
        errors.lastName = i18n.t('registerLoginScreens.LAST_NAME_REQUIRED');
      }
      if (!user.gender) {
        errors.gender = i18n.t('registerLoginScreens.GENDER_REQUIRED');
      }
      if (!user.birthDate) {
        errors.birthDate = i18n.t('registerLoginScreens.BIRTH_DATE_REQUIRED');
      }

      if (!user.postcode) {
        errors.postcode = i18n.t('registerLoginScreens.POSTCODE_REQUIRED');
      }

      if (!user.termsAccepted) {
        errors.termsAccepted = i18n.t(
          'registerLoginScreens.TERMS_ACCEPTED_REQUIRED'
        );
      }

      if (!RegisterContainer.isOver18(user.birthDate)) {
        errors.birthDate = i18n.t(
          'registerLoginScreens.OVER_18_YEARS_OLD_REQUIRED'
        );
      }

      this.setState({
        errors
      });
    }
  }

  handleThirdPageSubmit() {
    const { user } = this.state;
    const errors = Object.assign({}, this.state.errors);

    if (
      user.emergency_name &&
      user.emergency_phone_number &&
      user.emergency_relationship
    ) {
      this.props.register({
        ...user,
        invite_hash: this.state.inviteHash,
        birthDate: dateFormat(user.birthDate, 'yyyy-mm-dd')
      });
    } else {
      if (!user.emergency_name) {
        errors.emergency_name = i18n.t(
          'registerLoginScreens.EMERGENCY_CONTACT_NAME_REQUIRED'
        );
      }

      if (!user.emergency_phone_number) {
        errors.emergency_phone_number = i18n.t(
          'registerLoginScreens.EMERGENCY_CONTACT_PHONE_NUMBER_REQUIRED'
        );
      }

      if (!user.emergency_relationship) {
        errors.emergency_relationship = i18n.t(
          'registerLoginScreens.EMERGENCY_CONTACT_RELATIONSHIP_REQUIRED'
        );
      }

      this.setState({
        errors
      });
    }
  }

  goToPage(x) {
    this.setState({ page: x });
    scrollScreenToTop();
  }

  toggleTermsAccepted() {
    const { user, errors } = this.state;
    this.setState({
      user: {
        ...user,
        termsAccepted: !user.termsAccepted
      },
      errors: {
        ...errors,
        termsAccepted: false
      }
    });
  }

  routeToSignIn() {
    this.props.dispatch(push(routeConstants.SIGNIN_ROUTE));
  }

  render() {
    const { user } = this.state;
    let leftButtonContent = null;
    let onLeftButtonClick = null;
    if (this.state.page === 1) {
      leftButtonContent = (
        <div>
          {i18n.t('registerLoginScreens.ALREADY_MEMBER')}{' '}
          <b>{i18n.t('registerLoginScreens.SIGN_IN')}</b>
        </div>
      );
      onLeftButtonClick = this.routeToSignIn;
    } else {
      leftButtonContent = <div>{i18n.t('BACK')}</div>;
      onLeftButtonClick = () => this.goToPage(this.state.page - 1);
    }

    return (
      <div className="register-container">
        <SimpleFormWrapper
          onButtonClick={ this.handleSubmit }
          title={ i18n.t('registerLoginScreens.SIGN_UP') }
          buttonTitle={
            this.state.page === 1 || this.state.page === 2
              ? i18n.t('NEXT_STEP')
              : i18n.t('JOIN')
          }
          subtitle={
            this.state.page === 3
              ? i18n.t(
                'registerLoginScreens.SIGN_UP_EMERGENCY_CONTACT_SUBTITLE'
              )
              : i18n.t('registerLoginScreens.SIGN_UP_SUBTITLE')
          }
          description={
            this.state.page === 3
              ? i18n.t(
                'registerLoginScreens.SIGN_UP_EMERGENCY_CONTACT_DESCRIPTION'
              )
              : i18n.t('registerLoginScreens.SIGN_UP_DESCRIPTION')
          }
          backendError={ this.props.backendError }
          onLeftButtonClick={ onLeftButtonClick }
          leftButtonContent={ leftButtonContent }
        >
          <div className="form-group">
            {this.state.page === 1 && (
              <div>
                <div className="input-label email-input-label">
                  {i18n.t('registerLoginScreens.EMAIL')}
                </div>
                <input
                  name="email"
                  className={ `private-data form-control${
                    this.state.errors.email ? ' is-invalid' : ''
                  }` }
                  placeholder={ i18n.t(
                    'registerLoginScreens.SIGN_UP_EMAIL_PLACEHOLDER'
                  ) }
                  value={ user.email }
                  disabled={ this.state.inviteHash }
                  onChange={ this.handleChange }
                />
                {this.state.errors.email && (
                  <div className="error">{this.state.errors.email}</div>
                )}
                <div className="input-label email-input-label">
                  {i18n.t('registerLoginScreens.CONFIRM_EMAIL')}
                </div>
                <input
                  name="confirmEmail"
                  className={ `private-data form-control${
                    this.state.errors.email ? ' is-invalid' : ''
                  }` }
                  placeholder={ i18n.t(
                    'registerLoginScreens.SIGN_UP_EMAIL_PLACEHOLDER'
                  ) }
                  value={ user.confirmEmail }
                  disabled={ this.state.inviteHash }
                  onChange={ this.handleChange }
                />
                {this.state.errors.email && (
                  <div className="error">{this.state.errors.email}</div>
                )}
                <div className="input-label password-label">
                  {i18n.t('registerLoginScreens.PASSWORD')}
                </div>
                <input
                  name="password"
                  type="password"
                  className={ `private-data form-control${
                    this.state.errors.password ? ' is-invalid' : ''
                  }` }
                  placeholder={ i18n.t(
                    'registerLoginScreens.SIGN_UP_PASSWORD_PLACEHOLDER'
                  ) }
                  value={ user.password }
                  onChange={ this.handleChange }
                />
                {this.state.errors.password && (
                  <div className="error">{this.state.errors.password}</div>
                )}
                <div className="input-label password-label">
                  {i18n.t('registerLoginScreens.CONFIRM_PASSWORD')}
                </div>
                <input
                  name="confirmPassword"
                  type="password"
                  className={ `private-data form-control${
                    this.state.errors.password ? ' is-invalid' : ''
                  }` }
                  placeholder={ i18n.t(
                    'registerLoginScreens.SIGN_UP_PASSWORD_PLACEHOLDER'
                  ) }
                  value={ user.confirmPassword }
                  onChange={ this.handleChange }
                />
                {this.state.errors.password && (
                  <div className="error">{this.state.errors.password}</div>
                )}
              </div>
            )}

            {this.state.page === 2 && (
              <div>
                <div className="input-label">
                  {i18n.t('registerLoginScreens.FIRST_NAME')}
                </div>
                <input
                  name="firstName"
                  className={ `private-data form-control${
                    this.state.errors.firstName ? ' is-invalid' : ''
                  }` }
                  placeholder={ i18n.t(
                    'registerLoginScreens.SIGN_UP_FIRST_NAME_PLACEHOLDER'
                  ) }
                  value={ user.firstName }
                  onChange={ this.handleChange }
                />
                {this.state.errors.firstName && (
                  <div className="error">{this.state.errors.firstName}</div>
                )}

                <div className="input-label">
                  {i18n.t('registerLoginScreens.LAST_NAME')}
                </div>
                <input
                  name="lastName"
                  className={ `private-data form-control${
                    this.state.errors.lastName ? ' is-invalid' : ''
                  }` }
                  placeholder={ i18n.t(
                    'registerLoginScreens.SIGN_UP_LAST_NAME_PLACEHOLDER'
                  ) }
                  value={ user.lastName }
                  onChange={ this.handleChange }
                />
                {this.state.errors.lastName && (
                  <div className="error">{this.state.errors.lastName}</div>
                )}

                <div className="input-label">
                  {i18n.t('registerLoginScreens.BIRTH_DATE')}
                </div>
                <div
                  className={ `${this.state.errors.birthDate &&
                    'birth-date-wrapper-error private-data'}` }
                >
                  <DatePicker
                    hintText={ i18n.t(
                      'registerLoginScreens.SIGN_UP_BIRTH_DATE_PLACEHOLDER'
                    ) }
                    value={ this.state.user.birthDate }
                    onChange={ this.handleBirthDateChange }
                    openToYearSelection={ true }
                    textFieldStyle={ {
                      width: '100%',
                      paddingBottom: '20px'
                    } }
                    container="inline"
                  />
                </div>
                {this.state.errors.birthDate && (
                  <div className="birth-date-error">
                    {this.state.errors.birthDate}
                  </div>
                )}

                <div className="input-label">
                  {i18n.t('registerLoginScreens.GENDER')}
                </div>

                <div className="gender-container">
                  {gender.map(x => (
                    <div key={ x.value } className="gender-option-container">
                      <input
                        type="radio"
                        name="gender"
                        value={ x.value }
                        onChange={ this.handleChange }
                      />
                      <div className="gender-option-label">{x.label}</div>
                    </div>
                  ))}
                </div>
                {this.state.errors.gender && (
                  <div className="error">{this.state.errors.gender}</div>
                )}

                <div className="input-label">
                  {i18n.t('registerLoginScreens.POSTCODE')}
                </div>
                <input
                  name="postcode"
                  className={ `private-data post-code-input form-control${
                    this.state.errors.postcode ? ' is-invalid' : ''
                  }` }
                  placeholder={ i18n.t(
                    'registerLoginScreens.SIGN_UP_POSTCODE_PLACEHOLDER'
                  ) }
                  value={ user.postcode }
                  onChange={ this.handleChange }
                />
                {this.state.errors.postcode && (
                  <div className="error">{this.state.errors.postcode}</div>
                )}

                <div className="checkbox-container">
                  <div className="checkbox">
                    <Checkbox
                      name="termsAccepted"
                      checked={ user.termsAccepted }
                      onCheck={ this.toggleTermsAccepted }
                      inputStyle={ { fontSize: '12px', color: 'red' } }
                      iconStyle={ {
                        fill: this.state.errors.termsAccepted ? 'red' : ''
                      } }
                    />
                  </div>
                  <span
                    className="terms-accept-container"
                    style={ {
                      fontSize: '12px',
                      color: this.state.errors.termsAccepted ? 'red' : 'black'
                    } }
                  >
                    {i18n.t('registerLoginScreens.I_ACCEPT_THE')}{' '}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://deucetennis.github.io/terms-and-conditions"
                    >
                      {i18n.t('registerLoginScreens.TERMS_AND_CONDITIONS')}
                    </a>{' '}
                    {i18n.t('registerLoginScreens.AND')}{' '}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://deucetennis.github.io/privacy"
                    >
                      {i18n.t('registerLoginScreens.PRIVACY_POLICY')}
                    </a>
                  </span>
                </div>
              </div>
            )}

            {this.state.page === 3 && (
              <div>
                <div className="input-label">
                  {i18n.t('registerLoginScreens.EMERGENCY_CONTACT_NAME')}
                </div>
                <input
                  name="emergency_name"
                  className={ `private-data form-control${
                    this.state.errors.emergency_name ? ' is-invalid' : ''
                  }` }
                  placeholder={ i18n.t(
                    'registerLoginScreens.EMERGENCY_CONTACT_NAME_PLACEHOLDER'
                  ) }
                  value={ user.emergency_name }
                  onChange={ this.handleChange }
                />
                {this.state.errors.emergency_name && (
                  <div className="error">
                    {this.state.errors.emergency_name}
                  </div>
                )}

                <div className="input-label">
                  {i18n.t(
                    'registerLoginScreens.EMERGENCY_CONTACT_PHONE_NUMBER'
                  )}
                </div>
                <input
                  name="emergency_phone_number"
                  className={ `private-data form-control${
                    this.state.errors.emergency_phone_number
                      ? ' is-invalid'
                      : ''
                  }` }
                  placeholder={ i18n.t(
                    'registerLoginScreens.EMERGENCY_CONTACT_PHONE_NUMBER_PLACEHOLDER'
                  ) }
                  value={ user.emergency_phone_number }
                  onChange={ this.handleChange }
                />
                {this.state.errors.emergency_phone_number && (
                  <div className="error">
                    {this.state.errors.emergency_phone_number}
                  </div>
                )}

                <div className="input-label">
                  {i18n.t(
                    'registerLoginScreens.EMERGENCY_CONTACT_RELATIONSHIP'
                  )}
                </div>
                <input
                  name="emergency_relationship"
                  className={ `private-data form-control${
                    this.state.errors.emergency_relationship
                      ? ' is-invalid'
                      : ''
                  }` }
                  placeholder={ i18n.t(
                    'registerLoginScreens.EMERGENCY_CONTACT_RELATIONSHIP_PLACEHOLDER'
                  ) }
                  value={ user.emergency_relationship }
                  onChange={ this.handleChange }
                />
                {this.state.errors.emergency_relationship && (
                  <div className="error">
                    {this.state.errors.emergency_relationship}
                  </div>
                )}

                <div className="input-label">
                  {i18n.t(
                    'registerLoginScreens.EMERGENCY_CONTACT_EXISTING_CONDITIONS'
                  )}
                </div>
                <textarea
                  name="emergency_existing_conditions"
                  className={ `private-data form-control${
                    this.state.errors.emergency_existing_conditions
                      ? ' is-invalid'
                      : ''
                  }` }
                  placeholder={ i18n.t(
                    'registerLoginScreens.EMERGENCY_CONTACT_EXISTING_CONDITIONS_PLACEHOLDER'
                  ) }
                  value={ user.emergency_existing_conditions }
                  onChange={ this.handleChange }
                />
                {this.state.errors.emergency_existing_conditions && (
                  <div className="error">
                    {this.state.errors.emergency_existing_conditions}
                  </div>
                )}
              </div>
            )}
          </div>
        </SimpleFormWrapper>
      </div>
    );
  }
}

RegisterContainer.propTypes = {
  register: PropTypes.func.isRequired,
  backendError: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  inviteHash: PropTypes.string,
  inviteEmail: PropTypes.string
};

RegisterContainer.defaultProps = {
  backendError: '',
  inviteHash: '',
  inviteEmail: ''
};

const mapStateToProps = state => ({
  backendError: state.registration.error
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  register: user => dispatch(register(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterContainer);



// WEBPACK FOOTER //
// ./src/containers/RegisterContainer.js